/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Bulb({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M7.99.989a4.98 4.98 0 0 0-3.357 8.658 3.96 3.96 0 0 1 1.3 2.355l4.096.016a3.995 3.995 0 0 1 1.318-2.371A4.98 4.98 0 0 0 7.99.989Zm-3.38.046a5.98 5.98 0 0 1 7.407 9.355l-.009.007a3 3 0 0 0-1.028 2.143.5.5 0 0 1-.502.48l-5-.02a.5.5 0 0 1-.498-.482 2.96 2.96 0 0 0-1.01-2.122l-.007-.006a5.98 5.98 0 0 1 .647-9.355ZM5.98 14v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V14h1v.5a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5V14h1Z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M7.98 7.48a.5.5 0 0 1 .5.5v4.24a.5.5 0 0 1-1 0V7.98a.5.5 0 0 1 .5-.5Z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M7.95 6.48a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-1.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" clipRule="evenodd" /></svg>;
}
;